import clsx from 'clsx';
import * as React from 'react';
import css from './badge.module.scss';
import { Badge as BaseBadge } from '@mui/base/Badge';

type Props = {
  variant?: 'default' | 'inline' | 'standalone';
  color?: 'default' | 'success' | 'error';
};

function Badge({
  children,
  badgeContent,
  expand,
  variant = 'default',
  color = 'default',
}: React.ComponentProps<typeof BaseBadge> & Props) {
  return (
    <BaseBadge
      slotProps={{
        root: {
          className: clsx(
            css.root,
            expand && css['is-expanded'],
            variant && css[`variant-${variant}`],
            color && css[`color-${color}`],
          ),
        },
        badge: { className: css.badge },
      }}
      badgeContent={badgeContent}
    >
      {children}
    </BaseBadge>
  );
}

export default Badge;
